import moment from 'moment-timezone';
import type { Candle, FxIntradayDataProvider, Timeframe } from '../engine/types.ts';

const FX_ENDPOINT =
  process.env.REACT_APP_FX_INTRADAY_API_BASE || 'https://vidplay-api.deng-software.com/fx';

const timeframeMap: Record<Timeframe, string> = {
  '1m': '1min',
  '5m': '5min',
  '15m': '15min',
  '1h': '60min'
};

export const createFxProvider = (): FxIntradayDataProvider => {
  return {
    async fetchCandles(params) {
      const { symbol, timeframe, start, end } = params;
      const response = await fetch(FX_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Cache-Control': 'no-store'
        },
        cache: 'no-store',
        body: JSON.stringify({ currencyPair: symbol, timeInterval: timeframeMap[timeframe] })
      });

      if (!response.ok) {
        throw new Error(`FX intraday request failed: ${response.status}`);
      }

      const data = await response.json();
      const rows = Array.isArray(data?.data) ? data.data : [];
      const startMs = start ? Date.parse(start) : null;
      const endMs = end ? Date.parse(end) : null;

      return rows
        .map((row: any) => {
          const t = moment.tz(row.time, 'UTC').valueOf();
          return {
            t,
            o: row.open,
            h: row.high,
            l: row.low,
            c: row.close,
            v: row.volume ?? row.v
          } as Candle;
        })
        .filter((candle: Candle) => {
          if (startMs && candle.t < startMs) return false;
          if (endMs && candle.t > endMs) return false;
          return true;
        });
    }
  };
};
